import { createMuiTheme } from '@material-ui/core/styles';
import { ptBR } from '@material-ui/core/locale';

import { themeCispay } from './theme-cispay';

export const theme = createMuiTheme(themeCispay, ptBR);